import Api from '@/services/Api'

// load, create, and delete class logins for the authenticated user

export default {
  index() {
    return Api().get('classrooms');
  },
  post(credentials) {
    return Api().post('classrooms', credentials);
  },
  put(classroomId, data) {
    return Api().put(`classrooms/${classroomId}`, data);
  },
  createSchoolwideClassroom(credentials) {
    return Api().post('createSchoolwideClassroom', credentials);
  },
  delete(classId) {
    return Api().delete(`classrooms/${classId}`);
  }
}